var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoachTaskCheckedButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    fill: "#3446FB",
    fillOpacity: 0.1,
    stroke: "#3446FB",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8749 25.1247L13.8749 25.1247L8.78614 20.036L8.78611 20.0359C7.93796 19.1882 7.93796 17.8119 8.78611 16.9642L8.78616 16.9641C9.63389 16.116 11.0102 16.1159 11.8584 16.9641L11.8584 16.9642L14.8903 19.9956L14.8904 19.9957C15.1779 20.2826 15.6442 20.2825 15.932 19.9958L15.9322 19.9956L24.1416 11.7861L24.1416 11.7861C24.9894 10.938 26.3657 10.9379 27.2139 11.7861C27.6212 12.1934 27.85 12.7461 27.85 13.322C27.85 13.898 27.6212 14.4507 27.2139 14.858L16.9471 25.1247C16.0989 25.9729 14.7226 25.9729 13.8749 25.1247Z",
    fill: "#3446FB",
    stroke: "#E8EAEE",
    strokeWidth: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachTaskCheckedButton);
export default __webpack_public_path__ + "static/media/CoachTaskCheckedButton.8e631b1c22da365d0c2ff2b55d2b0ab1.svg";
export { ForwardRef as ReactComponent };